import { Button, ButtonProps } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

export type SaveButtonProps = Omit<ButtonProps, 'icon'>;

export function SaveButton(props: SaveButtonProps) {
  return <Button type="primary" {...props} icon={<CheckOutlined />} />;
}
